import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caikuma_running.png'


const _withScopeId = n => (_pushScopeId("data-v-352741d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative mascot-outer" }
const _hoisted_2 = { class: "stepbar" }
const _hoisted_3 = { class: "bar" }
const _hoisted_4 = { class: "step-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "position-absolute",
        src: _imports_0,
        style: _normalizeStyle(_ctx.mascotImageStyle)
      }, null, 4)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "active",
          style: _normalizeStyle(_ctx.barStyle)
        }, null, 4)
      ]),
      _createTextVNode(),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxValue, (index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([{ active: _ctx.currentValue >= index }, "step-list-item"])
          }, [
            (_ctx.reverse)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.maxValue - index + 1), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(index), 1)
                ], 64))
          ], 2))
        }), 128))
      ])
    ])
  ]))
}